import en from './en'
import it from './it'

export default {
  it,
  en
}
